import { render, staticRenderFns } from "./Followup211.vue?vue&type=template&id=9aa3eef2&scoped=true&"
import script from "./Followup211.vue?vue&type=script&lang=ts&"
export * from "./Followup211.vue?vue&type=script&lang=ts&"
import style0 from "./Followup211.vue?vue&type=style&index=0&id=9aa3eef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa3eef2",
  null
  
)

export default component.exports